import { FileExcelOutlined, FileOutlined, FilePdfOutlined, FileWordOutlined } from '@ant-design/icons';
import { UPLOAD_URL_RE } from '@cult/schemas';
import type { ReactElement } from 'react';

/**
 * True for files served by CULT itself. Anything else (e.g. an external link saved before the API
 * validated attachments) is never loaded or linked, so it can't track who views the record.
 */
export const isUploadUrl = (url: string): boolean => UPLOAD_URL_RE.test(url);

export const isPreviewableImage = (attachment: { mime: string; url: string }): boolean =>
  attachment.mime.startsWith('image/') && isUploadUrl(attachment.url);

export const iconFor = (mime: string): ReactElement => {
  if (mime === 'application/pdf') return <FilePdfOutlined />;
  if (mime === 'application/msword' || mime.endsWith('wordprocessingml.document')) {
    return <FileWordOutlined />;
  }
  if (mime === 'application/vnd.ms-excel' || mime.endsWith('spreadsheetml.sheet')) {
    return <FileExcelOutlined />;
  }
  return <FileOutlined />;
};

export const formatSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
};
